import React from 'react'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
const Puz31 = () => {
    return (
        <div>
            <NavLink to='/category/Puzzels/Puzzel32'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Puzzels/Puzzel30'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'70px'}}>&lt;-   Previous page </Button>
</NavLink>
<article class="container">
    <h1 class="title">Minimum cut Puzzle</h1>
   
    <div class="text">
        <p><strong><u>Puzzle</u>:</strong> You have got someone working for you for five days and a gold bar to pay him.
            You must give them a piece of gold at the end of every day. What are the fewest number of cuts to the bar of
            gold that will allow you to pay him 1/5th each day?&nbsp;</p>
        <p>&nbsp;&nbsp;</p>
        <p>&nbsp;&nbsp;</p>
        <p>&nbsp;&nbsp;</p>
        <p>&nbsp;&nbsp;</p><br/>
        <div id="AP_G4GR_5"></div>
      
        <p><strong><u>Answer</u>:</strong> 2 cuts.&nbsp;</p>
        <p><strong><u>Solution</u>:</strong>&nbsp;<br/>&nbsp;</p>
       <p><strong>Explanation 1:</strong>&nbsp;<br/>&nbsp;</p>
        <div>After two cut there are&nbsp;three&nbsp;pieces of [1 unit and two 2 units] or [two 1 units and one 3 unit].
            Now perform the following transactions.</div>
        <p><strong>[1 unit and two 2 units]</strong>&nbsp;</p>
        <p>&nbsp;</p>
        <figure class="table">
            <table>
                <thead>
                    <tr>
                        <th>Days</th>
                        <th>Gold Bars(Vendor)</th>
                        <th>Gold Bars(Worker)</th>
                        <th>Comments</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Day 0</td>
                        <td>[1, 2, 2]</td>
                        <td>[]</td>
                        <td>Initially Worker have 0 Gold Bars unit.</td>
                    </tr>
                    <tr>
                        <td>Day 1</td>
                        <td>[2, 2]</td>
                        <td>[1]</td>
                        <td>Pay the worker Gold Bar with 1 unit.</td>
                    </tr>
                    <tr>
                        <td>Day 2</td>
                        <td>[1, 2]</td>
                        <td>[2]</td>
                        <td>Pay the worker Gold with 2 units and take back the gold bar with 1 unit.</td>
                    </tr>
                    <tr>
                        <td>Day 3</td>
                        <td>[2]</td>
                        <td>[1, 2]</td>
                        <td>Pay the worker Gold Bar with 1 unit.</td>
                    </tr>
                    <tr>
                        <td>Day 4</td>
                        <td>[1]</td>
                        <td>[2, 2]</td>
                        <td>Pay the worker Gold with 2 units and take back the gold bar with 1 unit.</td>
                    </tr>
                    <tr>
                        <td>Day 5</td>
                        <td>[]</td>
                        <td>[1, 2, 2]</td>
                        <td>Pay the worker with only left Gold Bar with 1 unit.</td>
                    </tr>
                </tbody>
            </table>
        </figure>
        <p><strong>[two 1 units and one 3 unit]</strong>&nbsp;</p>
        <p>&nbsp;</p>
        <figure class="table">
            <table>
                <thead>
                    <tr>
                        <th>Days</th>
                        <th>Gold Bars(Vendor)</th>
                        <th>Gold Bars(Worker)</th>
                        <th>Comments</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Day 0</td>
                        <td>[1, 1, 3]</td>
                        <td>[]</td>
                        <td>Initially Worker have 0 Gold Bars unit.</td>
                    </tr>
                    <tr>
                        <td>Day 1</td>
                        <td>[1, 3]</td>
                        <td>[1]</td>
                        <td>Pay the worker Gold Bar with 1 unit.</td>
                    </tr>
                    <tr>
                        <td>Day 2</td>
                        <td>[3]</td>
                        <td>[1,1]</td>
                        <td>Pay the worker Gold with other 1 units.</td>
                    </tr>
                    <tr>
                        <td>Day 3</td>
                        <td>[1,1]</td>
                        <td>[3]</td>
                        <td>Pay the worker Gold Bar with 3 unit and take back all the gold bar with 1 unit.</td>
                    </tr>
                    <tr>
                        <td>Day 4</td>
                        <td>[1]</td>
                        <td>[1, 3]</td>
                        <td>Pay the worker Gold with 1 unit.</td>
                    </tr>
                    <tr>
                        <td>Day 5</td>
                        <td>[]</td>
                        <td>[1, 1, 3]</td>
                        <td>Pay the worker with only left Gold Bar with 1 unit.</td>
                    </tr>
                </tbody>
            </table>
        </figure>
     
    </div>
</article>
        </div>
    )
}

export default Puz31
